// ============================================================================
// JAPANESE TRANSLATIONS - CHAPTER 8: いと高き方の助け (ボーナス)
// ============================================================================
// レベル92 (1つのボーナスレベル、3つの質問)

export const chapter8Translations = {
  name: "いと高き方の助け",
  description: "いと高き方の隠れ場に住む者は、全能者の陰に宿る",
  
  spiritualWisdom: {
    principle: "あなたは山の頂上に到達し、知識は獲得されました",
    scripture: "いと高き方の隠れ場に住む者は、全能者の陰に宿る (詩篇91:1)",
    application: "揺るぎない信仰には、人生経験、憐れみ、そしてイエスの真の愛が必要です。試練はあなたの心、選んだ真の道を試すでしょう。"
  },
  
  levels: {
    92: {
      name: "いと高き方の隠れ場",
      challenge: "あなたは山の頂上にいます...しかし揺るぎない信仰は今始まります...",
      easy: {
        question: "イエスはあなたにとって個人的に誰ですか?",
        options: [
          "単なる預言者",
          "私の個人的な主であり救い主",
          "伝説",
          "哲学者"
        ],
        hint: "私たちを救うために命を捧げる方",
        funFact: "✝️ イエスは神です!彼は単なる歴史上の人物ではありません - 彼は生きており、私たち一人一人と個人的な関係を望んでいます!"
      },
      medium: {
        question: "なぜダニエルのように断食することで、神をよりよく聞くことができるのでしょうか?",
        options: [
          "体重を減らすため",
          "愛するものを断ち、変えられた心を持つため",
          "他人に印象を与えるため",
          "より強くなるため"
        ],
        hint: "最も愛するものを、静けさと知恵の中で自分自身から奪いましょう",
        funFact: "🙏 霊的な断食は、私たちの心を深い変容 - しばしば痛みを伴う - に備え、神に近づけます!"
      },
      hard: {
        question: "この獲得したすべての知識に対する心の真の応答は何ですか?",
        options: [
          "今、私は完璧です",
          "イエスよ、私はあなたに心を捧げ、バプテスマを受けたいです",
          "私は他の人よりよく知っています",
          "もう助けは必要ありません"
        ],
        hint: "真の信仰は完全な降伏とイエスへの献身につながります",
        funFact: "🌟✨ あなたは山の頂上に到達し、知識は獲得されました ✨\n\n💖 揺るぎない信仰には、人生経験、憐れみ、そしてイエスの真の愛が必要です 💖\n\n🔥 人生のさまざまな試練は、あなたの道、私たちが選ぶ真の道、私たちの心を試すでしょう 🔥\n\n😔 私たちは不完全なままであり、私たちの欲望は数多く、利益や個人的な快適さへの愛があまりにもしばしば私たちの利己的な優先事項になります 😔\n\n🙏 神に知恵、その愛、その力を求め、謙虚に自分の弱さを認めましょう。なぜなら、私たちは神から何も隠すことができないからです...何も 🙏\n\n🥖 ダニエルのように断食しましょう:最も愛するものを、静けさと知恵の中で、しばらくの間自分自身から奪いましょう 🥖\n\n💫 これにより、神をよりよく聞くことができ、深い変容に備えた心の準備ができます 💫\n\n🌙 そうすれば、ヨセフのように、夢と幻がより明確になります 🌙\n\n⚠️ 傲慢に注意してください:'私はいつも正しい'や'私はよく知っている'に屈しないでください ⚠️\n\n🎁 なぜなら、神の啓示は並外れた恵みだからです 🎁\n\n💝 信仰を持つことは、関係と心の自由な道に入ることです 💝\n\n🦸‍♂️ それはあなたを強力な英雄にし、不可能なことを可能にします 🦸‍♂️\n\n✝️ 知識の頂点で、誠実な心は言います:'イエスよ、私はあなたに心を捧げ、バプテスマを受けたいです' ✝️\n\n🏔️ あなたは山の頂上に到達しました。しっかりつかまり、忍耐してください! 🏔️\n\n⬇️ 下山し、この貴重な宝を運ばなければなりません:永遠の命の希望 ⬇️\n\n🏆✨ ブラボー!私たちはあなたを誇りに思います ✨🏆\n🌟 勇気ある平和の担い手よ、勇気を 🌟\n🕊️✨ 神があなたを祝福しますように ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
